/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from 'react';
import {ThumbnailFigure} from "../../atoms/ThumbnailFigure";
import Block from "../../atoms/layout/Block";
import {useI18N} from "../../hoc/withI18N";
import {ISearchGridCard} from "../../../interfaces/pages/ISearchResults";


export const SearchGridCard: FunctionComponent<ISearchGridCard> = ({result}) => {

    const translate = useI18N();

    return (<Block
        className={`finder-card col-xs-12 col-sm-6 col-md-4 col-lg-3 p-flex p-flex-column`}>
        <div className="thumbnail thumbnail--recipe">
            <ThumbnailFigure
                link={result.link}
                image={result.fileReference}
                altText={result.title}
                altImage=""
                useAltImage={false}
                showReferenceImageFirst={false}
                position=""
                materialNumbers=''>
            </ThumbnailFigure>
            <div className="caption card">
                <h3 className="p-margin-top-sm p-margin-bottom-sm">
                    <a href={result.link} className="p-color-black">
                        {result.title}
                    </a>
                </h3>
            </div>
            <div className="caption p-flex p-flex-align-center p-justify-space-between small finder-link">
                <p className="finder-link__text">
                    <a href={result.link} className="finder-link__link">{translate("Read more")}</a>
                </p>
            </div>
        </div>
    </Block>)

}
